module.exports = __webpack_public_path__ + "6b5b39acd3745e33a11671077999e3ef.pdf";